export default __webpack_public_path__ + "images/7eb40de67f9cba362c97f90d129e89d6-spa.jpg";